/**
 * Card — light-surface container with token-based border, radius, shadow.
 * Accepts an optional header slot for section title + action.
 */
import type { ReactNode } from 'react';

const cls = (...parts: (string | false | undefined | null)[]) =>
  parts.filter(Boolean).join(' ');

export function Card({
  children,
  className,
  padding = true,
  header,
}: {
  children: ReactNode;
  className?: string;
  /** Set false for overflow tables or custom padding. */
  padding?: boolean;
  header?: { title: ReactNode; action?: ReactNode };
}) {
  return (
    <div
      className={cls(
        'app-shell-surface rounded-card border border-border shadow-card backdrop-blur-xl',
        padding && 'p-4',
        className,
      )}
    >
      {header && (
        <div className="mb-3 flex items-center justify-between gap-2">
          <span className="text-small font-semibold text-ink">{header.title}</span>
          {header.action && <span>{header.action}</span>}
        </div>
      )}
      {children}
    </div>
  );
}
